import LogInModel from './login.model'

let storeContent = utils.generateStore({
	LogInModel,
	lang: LogInModel.lang,
	page: 1,
	token: ''
})

export default {
	state() {
		return {
			...storeContent.state
		};
	},
	getters: {
		...storeContent.getters
	},
	mutations: {
		...storeContent.mutations
	},
	actions: {
		async sendForgotPasswordRequest(ctx, payload) {
			try {
				ctx.commit('loading', true)
				let data = payload.ref.form_data_

				if (await payload.ref.isValid()) {
					let res = await api.fetchEndpoint({
						resource: 'auth',
						action: 'user:forgot_password',
						data: {
							email: data.email,
						},
						meta_data: {}
					})

					$notify('success', 'Token Sent', 'Forgot password token sent. Check your email.', 5)
					ctx.commit('page',1)
				}
				ctx.commit('loading', false)
			} catch (err) {
				ctx.commit('loading', false)
				throw err
			}
		},
		async resendOTP(ctx) {
			try {
					ctx.commit('loading', true)
					let msisdn = $session.get('msisdn')

					let res = await api.fetchEndpoint({
						msisdn,
					}, '/auth/v1/validate-user', { method: 'POST' })

					await $session.set('otpUser', res.data)
					$notify('success', 'OTP Sent', `OTP has been re-sent to your phone number`, 5)
					ctx.commit('loading', false)
			} catch (err) {
					ctx.commit('loading', false)
					throw err
			}
		},
		async validateOTP(ctx, payload) {
			try {
				ctx.commit('loading', true)
				let data = payload.ref.form_data_
				console.log(data)

				if (await payload.ref.isValid()) {
					let user = await $session.get('user')
					let res = await api.fetchEndpoint({
						action: 'otp:verify',
						resource: 'auth',
						data: {
							user_id: user._id,
							otp: data.otp,
							remember_me: false,
						},
						meta_data: {}
					})

					ctx.dispatch('logInActions',{res,payload})
				}

				ctx.commit('loading', false)
			} catch (err) {
					ctx.commit('loading', false)
					throw err
			}
		},
		async resetPassword(ctx, payload) {
			try {
					ctx.commit('loading', true)
					let data = payload.ref.form_data_
					let user = await $session.get('otpUser')

					if (data.password !== data.confirmPassword) {
						$notify('warning', 'Validation Error', `Password does not match Confirm Password.`, 10)
						ctx.commit('loading', false)
						return false
					}

					if (await payload.ref.isValid()) {
						let res = await api.fetchEndpoint({
							email: user.email,
							password: data.password
						}, '/auth/v1/reset', { method: 'POST' })

						$notify('success', 'Password Reset', `Password Reset Succesfull`, 10)
						ctx.commit('page', 1)
					}

					ctx.commit('loading', false)
			} catch (err) {
					ctx.commit('loading', false)
					throw err
			}
		},
		async logInActions(ctx,{res,payload}){
			try {
				await $session.set('token', `Bearer ${res.result.auth_token}`)
				// payload.router.push({ name: process.env.VUE_APP_AUTH_SUCCESS_COMPONENT || 'Typography'})
				await ctx.dispatch('mainLogInAction',{res,payload})
			} catch (err) {
				throw err
			}
		},
		async logIn(ctx, payload) {
			try {
					ctx.commit('loading', true)
					let data = payload.ref.form_data_

					if (await payload.ref.isValid()) {
						let res = await api.fetchEndpoint({
							action: 'login',
							resource: 'auth',
							data: {
								email: data.email,
								password: data.password,
								remember_me: false,
							},
							meta_data: {}
						})

						await $session.set('user', res.result.user)
						await $session.set('role', res.result.role)
						ctx.commit('user_role', res.result.role[0])

						if(!res.result.has_otp){
							ctx.dispatch('logInActions',{res,payload})
						}else{
							ctx.commit('page',3)
							$notify('success', 'OTP Sent.', res.result.msg, 10)
						}
					}
					ctx.commit('loading', false)
			} catch (err) {
					ctx.commit('loading', false)
					throw err
			}
		},
		async verifyEmail(ctx, payload) {
			try {
				ctx.commit('loading', true)
				let data = payload.ref.form_data_

				if (await payload.ref.isValid()) {
					let res = await api.fetchEndpoint({
						resource: 'auth',
						action: 'email:verify',
						data: {
								token: ctx.getters.token,
								password: data.confirm_password,
						},
						meta_data: {}
					})

					$notify('success', 'Email Verified', 'Email Successfully Verified', 5)
					payload.router.push({ name: 'LogIn' })
				}
				ctx.commit('loading', false)
			} catch (err) {
				ctx.commit('loading', false)
				throw err
			}
		},
		async verifyForgotPassword(ctx, payload) {
			try {
				ctx.commit('loading', true)
				let data = payload.ref.form_data_

				if (await payload.ref.isValid()) {
					let res = await api.fetchEndpoint({
						resource: 'auth',
						action: 'user:reset_password_token',
						data: {
								token: ctx.getters.token,
								password: data.confirm_password,
						},
						meta_data: {}
					})

					$notify('success', 'Password Changed', 'Password successfully changed, Log in with your new password', 5)
					payload.router.push({ name: 'LogIn' })
				}
				ctx.commit('loading', false)
			} catch (err) {
				ctx.commit('loading', false)
				throw err
			}
		},
		checkToken(ctx,route){
			ctx.commit('token','')
			if(!route.query && !route.query.token || route.query.token.length < 100 || route.query.token.split('.').length !== 3){
				$notify('error', 'Invalid Token', `The token provided is invalid`, 10)
				return false
			}
			ctx.commit('token',route.query.token)
		}
	}
};